import { GroupItems } from "~/components/groups/group-item";
import React, { useEffect } from "react";
import { GroupedEntityType, OutputDesignType } from "~/gql/graphql";
import { Modal, Select, TreeSelect } from "antd";
import { useQuery } from "@apollo/client";
import { filteredDesignsQuery } from "~/components/docx-proposal/graphql-queries";
import { useGroupItems } from "~/components/groups/hooks/use-group-items";

type Props = {
  open: boolean;
  close: () => void;
  onSelect: (designId: number) => void;
};
export const SelectDesignModal: React.FC<Props> = ({ open, close, onSelect }) => {
  const {
    data: groupItems,
    groupedForCascade,
    loading,
  } = useGroupItems(GroupedEntityType.ProposalOutput);
  const [selectedGroupItem, setSelectedGroupItem] = React.useState<number | null>(null);
  const [selectedDesign, setSelectedDesign] = React.useState<number | null>(null);

  return (
    <Modal
      confirmLoading
      title="Select Design"
      onCancel={() => close()}
      open={open}
      footer={null}
      onOk={() => (selectedDesign ? onSelect(selectedDesign) : close())}
    >
      <div style={{ width: "100%" }}>
        <TreeSelect
          onSelect={(val) => setSelectedGroupItem(val)}
          style={{ width: "100%" }}
          treeData={groupedForCascade}
        />
        {selectedGroupItem && (groupItems?.groupItems.length ?? 0) > 0 && (
          <Select
            options={groupItems?.groupItems
              .find((x) => x.id == selectedGroupItem)
              ?.outputDesigns?.filter((x) => x.active)
              .map((x) => ({
                label: x.title,
                value: x.id,
              }))}
            style={{ width: "100%", marginTop: 8 }}
            onSelect={(val) => {
              onSelect(val);
              close();
            }}
            placeholder="Select a design"
          />
        )}
      </div>
    </Modal>
  );
};
